import styled from 'styled-components';

import { StyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

interface ButtonsWrapperProps {
	isTextAlign?: boolean;
}

interface ButtonProps {
	isActive: boolean;
	isBold?: boolean;
	isItalic?: boolean;
	isUnderline?: boolean;
}

const ButtonsWrapper = styled('div')`
	display: flex;
	margin-bottom: 20px;
	border-radius: 6px;

	${(props: ButtonsWrapperProps) => (
		props.isTextAlign && `margin: 25px 0 40px;`
	)}
`;

const Button = styled('button').attrs({
	type: 'button',
})`
	box-sizing: border-box;
	flex: 1 1 33.33%;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 43px;
	margin: 0;
	padding: 0 10px;
	border: 0;
	outline: 0;
	background-color: ${(props: ButtonProps) => props.isActive
		? `${hexToRgba(StyleColor.Blue600, 20)}`
		: `${StyleColor.White}`};
	font-family: HelveticaNeue, sans-serif;
	font-size: 18px;
	line-height: 43px;
	color: ${StyleColor.Blue600};
	cursor: pointer;

	&:first-child {
		border-radius: 6px 0 0 6px;
	}

	&:last-child {
		border-radius: 0 6px 6px 0;
	}

	&:not(:last-child) {
		border-right: 1px solid ${StyleColor.Grey50};
	}

	svg {
		width: 22px;
		height: 17px;
		fill: currentColor;
	}

	${(props: ButtonProps) => {
		if (props.isBold) {
			return `font-weight: bold;`;
		}
		if (props.isItalic) {
			return `
				font-family: Times, 'Times New Roman', serif;
				font-style: italic;
			`;
		}
		if (props.isUnderline) {
			return `text-decoration: underline;`;
		}
		return;
	}}
`;

export {
	ButtonsWrapper,
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/TextPanel/styles.ts